/* ============
 * code Transformer
 * ============
 */

import Transformer from './transformer';

export default class AdditionalCodeTransformer extends Transformer {

  static fetch(code) {
    return {
      id: code.id,
      code: code.code,
      factor: code.factor,
      description: code.description,
      vatable: code.vatable,
      excisable: code.excisable,
    };
  }

  static send(code) {
    return {
      id: code.id,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/additionalCode.js